import Cookies from 'js-cookie';
import HttpClient from '../../HttpClient';
import {baseURL} from '../../url';

class Definitions extends HttpClient {

    constructor(Callback) {
        // const url = process.env.API_URL;

        super(Callback, {
            baseURL,
            headers: {},
            Callback,
        });
        this.setHeader('Content-Type', 'application/json');
        this.setHeader('Accept', 'application/json');
        this.setBearerAuth(`Bearer  ${Cookies.get('token')}`);

    }

    static request(Callback) {
        return new Definitions(Callback);
    }


    FilterDetails() {
        return this.get('Definitions/FilterDetails');
    }


    FilterBranch() {
        return this.get('Definitions/branch');
    }

    FilterPalletStatus() {
        return this.get('Definitions/palletStatus');
    }

    FilterProductLine() {
        return this.get('Definitions/productLine');
    }

    FilterLocation() {
        return this.get(`Definitions/locations`);
    }

    FilterQcStatus() {
        return this.get('Definitions/QcStatus');
    }



    FilterRows() {
        return this.get('Definitions/Rows');
    }

    FilterWarningTypes() {
        return this.get('Definitions/WarningTypes');
    }


}

export default Definitions;
